/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Never_3Inputs */

const en_bot_never_3 = /** @type {(inputs: Bot_Never_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass captchas, paywalls, bot challenges or firewalls. As soon as such a page appears, BystepBot stops.`)
};

const id_bot_never_3 = /** @type {(inputs: Bot_Never_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menembus captcha, paywall, tantangan bot, atau firewall. Begitu halaman seperti itu muncul, BystepBot berhenti.`)
};

/**
* | output |
* | --- |
* | "Bypass captchas, paywalls, bot challenges or firewalls. As soon as such a page appears, BystepBot stops." |
*
* @param {Bot_Never_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_never_3 = /** @type {((inputs?: Bot_Never_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Never_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_never_3(inputs)
	return en_bot_never_3(inputs)
});